import Vue from 'vue'
import Vuex from 'vuex'
import post from './modules/post'
import home from './modules/home'
import topic from './modules/topic'
import insight from './modules/insight'
import userInfor from './modules/userInfor'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    post,
    home,
    topic,
    insight,
    userInfor
  },
})